<template>
  <FormGroup>
    <h5 class="name">ตอน</h5>
    <SelectOptionObject
      :value="scheduleItem.episode"
      :options="episodes"
      :label="'label'"
      :placeholder="'เลือกตอน'"
      @onChanged="onSelectedEpisode"
      @onSearch="loadEpisodes" />
  </FormGroup>
</template>

<script>
import _ from 'lodash';
import { loadEpisodes, loadEpisodeById } from '@/episode/api';
import SelectOptionObject from '@/components/SelectOptionObject.vue';
import FormGroup from '@/components/FormGroup.vue';
import dateFormetter from '@/utils/dateFormatter';

export default {
  mixins: [dateFormetter],
  props: {
    scheduleItem: {
      type: Object,
      default: () => {},
    },
    updateScheduleItemStateError: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    FormGroup,
    SelectOptionObject,
  },
  data() {
    return {
      episodes: [],
    };
  },
  created() {
    this.loadEpisodes({ programId: this.scheduleItem.programId });
    this.loadEpisodeById(this.scheduleItem.episodeId);
  },
  watch: {
    programId(newValue) {
      this.loadEpisodes({ programId: newValue });
    },
  },
  computed: {
    programId() {
      return this.scheduleItem.programId;
    },
  },
  methods: {
    async loadEpisodeById(episodeId) {
      if (episodeId) {
        const response = await loadEpisodeById(episodeId);
        const episode = response.data;
        episode.label = episode.firstAiredAt ? `(${this.formatShortDate(episode.firstAiredAt)}) ${episode.title}` : episode.title;
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          episode,
        });
      }
    },
    async loadEpisodes(filter) {
      if (!filter) return;
      const response = await loadEpisodes(filter);
      this.episodes = response.data.data;
      if (this.episodes && this.episodes.length) {
        this.episodes = this.episodes.map((episode) => {
          return {
            ...episode,
            label: episode.firstAiredAt ? `(${this.formatShortDate(episode.firstAiredAt)}) ${episode.title}` : episode.title,
          };
        });
      }
    },
    onSelectedEpisode(selectedOption) {
      if (selectedOption) {
        const episode = _.cloneDeep(selectedOption);
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          episode,
          episodeId: episode.id,
          episodeTitle: episode.title,
          coverImage: episode.coverImage,
          coverImageCustom: episode.coverImageCustom,
          contentCategory: episode.contentCategory,
          tagline: episode.tagline,
          taglineCustom: episode.tagline,
        });
      } else {
        this.$emit('update:scheduleItem', {
          ...this.scheduleItem,
          episode: null,
          episodeId: null,
        });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/variables.scss';
</style>
